import type { IconName } from "@ips/ui-kit";

export const routeIconDefaults: Record<string, IconName> = {
  "/dashboard": "home",
  "/assets": "asset",
  "/documents": "document",
  "/maintenance": "maintenance",
  "/permits": "permit",
  "/procedures": "procedure",
  "/sgs-pir": "compliance",
  "/tank-integrity": "home",
  "/admin": "admin",
  "/rag": "rag",
};
